// One request at a time keeps rapid rating changes in order. Only the latest
// pending choice for each answer is retained; excess quota is silently dropped.
export function createFeedbackSender({fetcher = fetch, now = Date.now, timeoutMs = 4000} = {}) {
  const pending = new Map();
  let attempts = [];
  let draining = false;
  async function drain() {
    if (draining) return;
    draining = true;
    try {
      while (pending.size) {
        const [id, request] = pending.entries().next().value;
        pending.delete(id);
        const time = now();
        attempts = attempts.filter(value => value > time - 10000);
        if (attempts.length >= 3) continue;
        attempts.push(time);
        const abort = new AbortController();
        const timer = setTimeout(() => abort.abort(), timeoutMs);
        try {
          const response = await fetcher(request.url, {
            method: 'POST', credentials: 'include', signal: abort.signal,
            headers: {'Content-Type': 'application/json'}, body: JSON.stringify(request.body),
          });
          await response.body?.cancel();
        } catch {
          // Feedback never blocks the chat or rolls back the user's selection.
        } finally {clearTimeout(timer);}
      }
    } finally {draining = false;}
  }
  return (url, body) => {
    if (pending.size >= 3 && !pending.has(body.messageId)) return;
    pending.set(body.messageId, {url, body});
    void drain();
  };
}
